import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { useNavigate } from 'react-router-dom'

const DataPwError = () => {

	const App = useApp()
	const navigate = useNavigate()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={() => navigate('/home/dataList')} />,
			right: ""
		})
		
		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding center-cont">
				<i className="icon icon_error_circle" />
				<h3 className="intro-tit mt_30">증명서가 확인되지 않아요.</h3>
				<p className="intro-sub-tit mt_10">증명서를 다시 요청해보세요.</p>
			</div>
		</div>
	)
}

export default DataPwError
